import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {
  AccessCodeAndClientSecret,
  AuthFormNotificationType,
  AuthFormType,
} from '@shared/models/auth.interface';
import { AppService, LoadingService, SnackbarService } from '@shared/services/core';
import { AuthService } from '@shared/services/auth/auth.service';
import { BehaviorSubject} from 'rxjs';
import { ActivatedRoute,Router  } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ValidationErrors } from '@angular/forms';
import { ChangePasswordService } from '@shared/services/auth/change-password.service';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.scss']
})
export class SetPasswordComponent implements OnInit {
  setPasswordForm: FormGroup;
  showNewPassword = false;
  showConfirmPassword = false;
  passwordStrength: string = '';
  apiErrorMessage: string | null = null;
  @Output() notify = new EventEmitter<AuthFormNotificationType>();
  @Output() result = new EventEmitter<
    { code: string; logo: string } | undefined
  >();
  notClosed: boolean = false;
  notificationShown: boolean = false;
  notificationType: AuthFormNotificationType = 'ACCESSCODE_ERROR';
  currentForm: AuthFormType = 'LOGIN';
  lastForm$ = new BehaviorSubject<AuthFormType>('ACCESSCODE');
  readonly defaultLogo: string = '/assets/images/entireonhire-logo.svg';
  userLogo: string = this.defaultLogo;
  accessCode: string = '';
  companyCode: string | undefined;

  passwordErrors: string[] = [];
  firstPasswordError: string | null = null;
  token: string | undefined;
  code: string | undefined;
  private _qurParam: string = '';
  UserId: string = ''; 
  keyRef: string | undefined;
  constructor(
    private loadingService: LoadingService,
    private appService: AppService,
    private changePasswordService: ChangePasswordService,
    private _activeRoute: ActivatedRoute,
    private snackbarService: SnackbarService,
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {
    this.loadingService.showLoading();
    this.setPasswordForm = this.fb.group({
    newPassword: ['', [Validators.required, Validators.minLength(8),Validators.maxLength(20)]],
    confirmPassword: ['', [Validators.required]]
    }, { validators: this.passwordMatchValidator });
  }

  ngOnInit(): void {
    this._qurParam = this._activeRoute.snapshot.queryParams['se'];
    this.companyCode = this._activeRoute.snapshot.queryParams['ac'];
    this.token = this._activeRoute.snapshot.queryParams['tag'];
    this.code = this._activeRoute.snapshot.queryParams['code'];
    this.loadingService.stopLoading();;
    this.tokenCheck(this.token)
    let authStatusType = this._activeRoute.snapshot.queryParams['authStatus'];
    if (authStatusType) {
      this.showNotificationFor(authStatusType);
    }

    if (this._qurParam) {
      this.snackbarService.showErrorSnackBar(
        'Session Expired',
        'We apologize for the inconvenience, but your session has ended. Please log in again.',
        ''
      );
    }

    if (this.setPasswordForm.valid) {
      console.log('Password set successfully', this.setPasswordForm.value);
    } else {
      console.log('Form is invalid');
    }
    this.setPasswordForm.get('newPassword')?.valueChanges.subscribe(() => {
      this.setPasswordForm.updateValueAndValidity({ onlySelf: false });
    });
    
    this.setPasswordForm.get('confirmPassword')?.valueChanges.subscribe(() => {
      this.setPasswordForm.updateValueAndValidity({ onlySelf: false });
    });
  }

  passwordMatchValidator(form: FormGroup): ValidationErrors | null {
    const newPassword = form.get('newPassword');
    const confirmPassword = form.get('confirmPassword');
  
    if (!newPassword || !confirmPassword) return null;
  
    if (newPassword.value !== confirmPassword.value) {
      confirmPassword.setErrors({ passwordMismatch: true });  // 👈 Attach to control
      return { passwordMismatch: true };
    } else {
      // ⚠️ Don't override other errors
      if (confirmPassword.hasError('passwordMismatch')) {
        confirmPassword.setErrors(null);
      }
      return null;
    }
  }
  

   toggleNewPasswordVisibility() {
    this.showNewPassword = !this.showNewPassword;
  }
    toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  closeMessageBox() {
    this.notClosed = false;
  }

  showNotificationFor(notificationType: AuthFormNotificationType | null) {
    if (notificationType === null) this.notificationShown = false;
    else {
      this.notificationType = notificationType;
      this.notificationShown = true;
    }
  }

  checkPasswordStrength(password: string) {
  this.firstPasswordError = null; // Reset the error message
 const control = this.setPasswordForm.get('newPassword');
  this.firstPasswordError = null;
  control?.setErrors(null);
  // Check each condition and stop at the first unmet one
  // if (password.length < 8) {
  //   this.firstPasswordError = 'Password must be at least 8 characters long.';
  // } else  
  // if (!/[A-Z]/.test(password)) {
  //   this.firstPasswordError = 'Password must include at least one uppercase letter.';
  // } else if (!/[0-9]/.test(password)) {
  //   this.firstPasswordError = 'Password must include at least one number.';
  // } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
  //   this.firstPasswordError = 'Password must include at least one special character.';
  // }else if(password.length < 8){
  //   this.firstPasswordError = 'Password must be at least 8 characters long.';
  // }else if(password.length > 20){
  //   this.firstPasswordError = 'Password must not exceed 20 characters.';
  // }
  if (!/[A-Z]/.test(password)) {
    this.firstPasswordError = 'Password must include at least one uppercase letter.';
  } else if (!/[a-z]/.test(password)) {
    this.firstPasswordError = 'Password must include at least one lowercase letter.';
  } else if (!/[0-9]/.test(password)) {
    this.firstPasswordError = 'Password must include at least one number.';
  } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    this.firstPasswordError = 'Password must include at least one special character.';
  } else if (password.length < 8) {
    this.firstPasswordError = 'Password must be at least 8 characters long.';
  } else {
    this.firstPasswordError = ''; // No error
  }
if (this.firstPasswordError) {
    control?.setErrors({ strength: this.firstPasswordError });
  }
  // Calculate password strength
  const strength = 
    (password.length >= 8 ? 1 : 0) +
    (/[A-Z]/.test(password) ? 1 : 0) +
    (/[0-9]/.test(password) ? 1 : 0) +
    (/[!@#$%^&*(),.?":{}|<>]/.test(password) ? 1 : 0);

  switch (strength) {
    case 1:
    case 2:
      this.passwordStrength = 'Weak';
      break;
    case 3:
      this.passwordStrength = 'Medium';
      break;
    case 4:
      this.passwordStrength = 'Strong';
      break;
    default:
      this.passwordStrength = '';
  }
}

onSubmit(): void {
    if (this.setPasswordForm.valid) {
      this.changePassword();
    } else {
      this.setPasswordForm.markAllAsTouched(); // Optionally show all validation errors
      this.snackbarService.showErrorSnackBar('Error', 'Please fix the form errors before submitting.', '');
    }
  }
  
  changePassword() {
    this.loadingService.showLoading();
  
    try {
      const newPassword = this.setPasswordForm.get('newPassword')?.value;
  
      const recoverPassword = {
        AccessCode: this.accessCode,
        Password: newPassword,
        UserId: this.UserId,
        token: this.token,
        ShortCode: this.code,
        BaseURL: window.location.hostname, //
      };
  
      this.changePasswordService.resetPassword(recoverPassword).subscribe({
        next: (requestBody: any) => {
          try {
            let message = requestBody?.Message || 'Unexpected response';
  
            if (requestBody?.Data === true) {
              message= 'Password reset successfully'; 
             // this.notify.next('PASS_RESET_SUCCESS');
              this.snackbarService.showSuccessSnackBar('Success', requestBody?.Message, '');
              this.setPasswordForm.reset();
              
              this.notify.next(requestBody?.Message);
              this.passwordStrength = '';
              this.showNewPassword = false;
              this.showConfirmPassword = false;
  
              // ✅ Redirect to login
              this.router.navigate(['/login']);
            } else {
              this.setPasswordForm.get('confirmPassword')?.setErrors({ apiErrorMessage: message });
             
              this.snackbarService.showErrorSnackBar('Error', message, '');
            }
          } catch (innerErr) {
            this.snackbarService.showErrorSnackBar('Error', 'Something went wrong while processing the response.', '');
            console.error('Response handling error:', innerErr);
          } finally {
            this.loadingService.stopLoading();
          }
        },
        error: (err:any) => {
          console.error('API error:', err);
          this.snackbarService.showErrorSnackBar('Error', 'Failed to reset password. Please try again.', '');
          this.loadingService.stopLoading();
        }
      });
    } catch (outerErr) {
      console.error('Unexpected error:', outerErr);
      this.snackbarService.showErrorSnackBar('Error', 'Unexpected error occurred.', '');
      this.loadingService.stopLoading();
    }
  
    return true;
  }
 tokenCheck(param:any) {
    this.loadingService.showLoading();
   const datapost = {
    
  requestedSource: window.location.hostname  //"dev-clients.entirehr.com.au"

   }
    this.changePasswordService.checkToken(this.token,datapost).subscribe({
      next: (response: any) => {
        if (response?.httpStatusCode === 200) {
          this.accessCode = response?.data?.companyCode;
          this.UserId = response?.data?.userId;
          this.keyRef = response?.data?.keyRef;
        } else {
          this.snackbarService.showErrorSnackBar('Error', response?.Message || 'Failed to check token.', '');
        }
        this.loadingService.stopLoading();
        
      },
      error: (err:any) => {
        this.router.navigate(['error/unauthorized']);
        console.error('Token check error:', err);
        this.snackbarService.showErrorSnackBar('Error', 'Failed to check token. Please try again.', '');
        this.loadingService.stopLoading();
      }
    });
  }

}
